/**
 * Trim by any symbol from both ends.
 * Usage:
 * trimBy('|hello|world|', '|'); // => 'hello|world'
 */
export const trimBy = (str: string, chars: string | Array<string>): string => {
  if (!str) {
    return '';
  }

  let start = 0;
  let end = str.length;

  while (start < end && chars.indexOf(str[start]) >= 0) {
    ++start;
  }

  while (end > start && chars.indexOf(str[end - 1]) >= 0) {
    --end;
  }

  return (start > 0 || end < str.length) ? str.substring(start, end) : str;
};
